import { render } from "./LegitScript.vue?vue&type=template&id=ff766c7c"
const script = {}

import "./LegitScript.vue?vue&type=style&index=0&id=ff766c7c&lang=css"

import exportComponent from "/var/www/web/httpd/getsmartrx.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__